import { RootState } from "@/store/types";
import { ActionTree, Module } from "vuex";
import {ProductMaterialAssociationState} from "@/modules/product_material_association/types";
import {saveProductMaterialAssociations} from "@/services/product_material_asssociation";

const actions: ActionTree<ProductMaterialAssociationState, RootState> = {
  async SAVE_PRODUCT_MATERIAL_ASSOCIATIONS(_, payload) {
    await saveProductMaterialAssociations(payload)
  },
}

export const product_material_association: Module<ProductMaterialAssociationState, RootState> = {
  actions,
}
